module.exports = __webpack_public_path__ + "img/p2.b43be335.svg";